var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1310,
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293.112 262.872h437.772v596.84H293.112z",
    fill: "#FD919F",
    "p-id": 1312
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M678.564 262.872h52.32v596.84h-52.32z",
    fill: "#E0667D",
    "p-id": 1313
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M345.436 262.872h333.128v539.504H345.436z",
    fill: "#FFFFFF",
    "p-id": 1314
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M634.436 262.872h44.128v539.504h-44.128z",
    fill: "#D5E6F7",
    "p-id": 1315
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M730.888 871.712H293.112a12 12 0 0 1-12-12V262.872a12 12 0 0 1 12-12h437.772a12 12 0 0 1 12 12v596.84a11.996 11.996 0 0 1-11.996 12z m-425.776-24h413.772V274.872H305.112v572.84z",
    fill: "#504774",
    "p-id": 1316
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M678.564 814.376H345.436a12 12 0 0 1-12-12V262.872a12 12 0 0 1 12-12h333.128a12 12 0 0 1 12 12v539.504a12 12 0 0 1-12 12z m-321.128-24h309.128V274.872H357.436v515.504z",
    fill: "#504774",
    "p-id": 1317
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M549.596 776.876c-25.252 0-25.252-27.54-25.252-56.692 0-8.708-2.432-15.276-7.232-19.528-2.768-2.452-7.452-2.452-10.224 0-4.796 4.252-7.232 10.82-7.232 19.528 0 29.152 0 56.692-25.252 56.692-23.816 0-30.232-44.432-31.424-81.712a21.26 21.26 0 0 0-3.512-11.124c-25.492-38.248-25.572-74.436-0.232-96.864 9.44-8.848 22.28-13.336 38.172-13.336 14.436 0 27.96 3.792 34.736 6.056 6.492-2.26 20.012-6.056 34.448-6.056 15.892 0 28.732 4.488 38.172 13.336 25.34 22.424 25.26 58.616-0.236 96.868a21.232 21.232 0 0 0-3.508 11.124c-1.188 37.272-7.608 81.708-31.424 81.708z m-72.188-179.036c-9.64 0-16.988 2.328-21.836 6.916l-0.332 0.304c-21.716 19.084-6.692 49.336 4.196 65.668a45.216 45.216 0 0 1 7.528 23.664c0.816 25.596 4.476 43.56 7.696 52.828 0.996-8.02 0.996-20.624 0.996-27.04 0-19.776 8.332-31.304 15.32-37.496 5.78-5.116 13.248-7.932 21.024-7.932s15.248 2.816 21.024 7.932c6.992 6.192 15.32 17.72 15.32 37.496 0 6.416 0 19.02 0.996 27.04 3.22-9.268 6.88-27.228 7.696-52.824 0.272-8.5 2.876-16.68 7.524-23.664 10.892-16.336 25.916-46.588 4.2-65.672a11.952 11.952 0 0 1-0.332-0.304c-4.848-4.588-12.196-6.916-21.836-6.916-11.456 0-22.792 3.372-27.136 4.82a23.664 23.664 0 0 1-14.916 0c-4.34-1.448-15.676-4.82-27.132-4.82z",
    fill: "#504774",
    "p-id": 1318
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M402.668 221.536h218.668v82.668h-218.668z",
    fill: "#A0D1F2",
    "p-id": 1319
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M576.668 221.536h44.668v82.668h-44.668z",
    fill: "#7BABF3",
    "p-id": 1320
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M621.332 316.204h-218.668a12 12 0 0 1-12-12V221.54a12 12 0 0 1 12-12h218.668a12 12 0 0 1 12 12v82.664a12 12 0 0 1-12 12z m-206.664-24h194.668V233.54h-194.668v58.664z",
    fill: "#504774",
    "p-id": 1321
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M542 233.54h-60a12 12 0 0 1-12-12v-27.252c0-23.16 18.84-42 42-42s42 18.84 42 42v27.252a12 12 0 0 1-12 12z m-48-24h36v-15.252c0-9.924-8.076-18-18-18s-18 8.076-18 18v15.252z",
    fill: "#504774",
    "p-id": 1322
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M566.4 473.352h-37.928v6.112a16.472 16.472 0 0 1-32.944 0v-6.112H457.6a27.3 27.3 0 0 0-27.3 27.3v50.016h163.396v-50.016a27.3 27.3 0 0 0-27.296-27.3z",
    fill: "#A0D1F2",
    "p-id": 1323
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M512 461.928c-5.776 0-11.316-0.996-16.472-2.808v20.344a16.472 16.472 0 0 0 32.944 0v-20.344a49.576 49.576 0 0 1-16.472 2.808z",
    fill: "#504774",
    "p-id": 1324
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M512 461.928c-27.432 0-49.668-22.236-49.668-49.668v-27.928c0-27.432 22.236-49.668 49.668-49.668s49.668 22.236 49.668 49.668v27.928c0 27.432-22.236 49.668-49.668 49.668z",
    fill: "#FFFFFF",
    "p-id": 1325
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M512 473.928c-34.004 0-61.668-27.664-61.668-61.668v-27.928c0-34 27.664-61.664 61.668-61.664s61.668 27.664 61.668 61.664v27.928c0 34.004-27.664 61.668-61.668 61.668z m0-127.26c-20.768 0-37.668 16.896-37.668 37.664v27.928c0 20.768 16.9 37.668 37.668 37.668s37.668-16.9 37.668-37.668v-27.928c0-20.768-16.9-37.664-37.668-37.664z",
    fill: "#504774",
    "p-id": 1326
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M593.696 562.668h-163.396a12 12 0 0 1-12-12v-50.016c0-21.672 17.628-39.3 39.3-39.3h37.924a12 12 0 0 1 12 12v6.112a4.48 4.48 0 0 0 8.944 0v-6.112a12 12 0 0 1 12-12h37.924c21.668 0 39.3 17.628 39.3 39.3v50.016a11.992 11.992 0 0 1-11.996 12z m-151.392-24h139.396v-38.016a15.32 15.32 0 0 0-15.3-15.3h-26.536c-2.72 12.888-14.176 22.584-27.86 22.584s-25.144-9.7-27.86-22.584H457.6a15.32 15.32 0 0 0-15.3 15.3v38.016z",
    fill: "#504774",
    "p-id": 1327
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M512 507.936a28.504 28.504 0 0 1-28.472-28.472v-20.344a12 12 0 0 1 15.98-11.32 37.848 37.848 0 0 0 24.984 0 12.008 12.008 0 0 1 15.98 11.32v20.344a28.504 28.504 0 0 1-28.472 28.472z m-4.472-34.168v5.696a4.48 4.48 0 0 0 8.944 0v-5.696c-2.968 0.212-5.976 0.212-8.944 0z",
    fill: "#504774",
    "p-id": 1328
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M634.436 561.292h182.896V688h-182.896z",
    fill: "#D5E6F7",
    "p-id": 1329
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M780.436 561.292h36.896V688h-36.896z",
    fill: "#A0D1F2",
    "p-id": 1330
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M817.332 700h-182.9a12 12 0 0 1-12-12v-126.712a12 12 0 0 1 12-12h182.9a12 12 0 0 1 12 12V688a12 12 0 0 1-12 12z m-170.896-24h158.9v-102.712h-158.9V676z",
    fill: "#504774",
    "p-id": 1331
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M775 631h-54a12 12 0 1 1 0-24h54a12 12 0 1 1 0 24zM748 664h-27a12 12 0 1 1 0-24H748a12 12 0 1 1 0 24z",
    fill: "#504774",
    "p-id": 1332
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.850ee2f903b9d0437b17e87e17d19cb5.svg";
export { ForwardRef as ReactComponent };